var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import ReviewEssential from "./reviewEssential";
import ReviewExtension from "./reviewExtension";
var Review = /** @class */ (function (_super) {
    __extends(Review, _super);
    function Review() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Review.Essential = ReviewEssential;
    Review.Extension = ReviewExtension;
    return Review;
}(React.Component));
export default Review;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/review/review.tsx
// module id = ayG1
// module chunks = 2